import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ClaudeDesktop } from '../claude-desktop/claude-desktop';
import { MatIconModule } from '@angular/material/icon'

@Component({
  imports: [MatIconModule],
  selector: 'app-copilot-vs-code',
  templateUrl: './copilot-vs-code.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './copilot-vs-code.css'
})
export class CopilotVsCode extends ClaudeDesktop {
  vs_code_link: string;
  vs_code_insiders_link: string;
  constructor() {
    super();
    this.vs_code_link = `vscode:mcp/install?${encodeURIComponent((this.getVsCodeLink()))}`;
    this.vs_code_insiders_link = `vscode-insiders:mcp/install?${encodeURIComponent((this.getVsCodeLink()))}`;
  }
  getVsCodeLink(): string {
    return `{"name": "todomcp","type": "http","url": "${this.url}/mcp"}`;
  }
}
